<!--
 * @Description: 资金管理资金列表
 * @Author: gao shuai
 * @Date: 2020-02-22 15:56:35
 * @LastEditTime: 2020-07-01 09:26:53
 * @LastEditors: gao shuai
 -->
<template>
  <div class="gs_container">
    <div class="gs_crumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span class="local">你的位置</span></el-breadcrumb-item>
        <el-breadcrumb-item>资金管理</el-breadcrumb-item>
        <el-breadcrumb-item>资金列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="opeartbox">
      <ul class="clearfix">
        <li>
          <span class='tit'>商户ID：</span>
          <span class="txtbox">
            <el-input style="width:120px;" size="small" type="number" v-model="tenantId"
              @input="tenantId = intNumber(tenantId)" placeholder="请输入内容"></el-input>
          </span>
        </li>
        <li>
          <span class='tit'>商户账号：</span>
          <span class="txtbox">
            <el-input style="width:120px;" size="small" v-model="accountnumber" placeholder="请输入内容"></el-input>
          </span>
        </li>
        <li>
          <span class='tit'>余额：</span>
          <span class="txtbox">
            <el-input style="width:100px;" type="number" size="small" v-model="ontherecharge"
              @input="ontherecharge = intNumber(ontherecharge)" placeholder="请输入内容"></el-input> --
            <el-input style="width:100px;" type="number" size="small" v-model="undertherecharge"
              @input="undertherecharge = intNumber(undertherecharge)" placeholder="请输入内容"></el-input>
          </span>
          <span class="mgl10">
            <el-button size="small" type="primary" @click="() => { pageIndex = 1; getlist() }">查询</el-button>
          </span>
          <span class="mgl10">
            <el-button size="small" type="primary" @click="() => { pageIndex = 1; autoSettlement() }">发起自动结算</el-button>
          </span>
        </li>
      </ul>
    </div>
    <div class="gs_tablebox">
      <el-table ref="moduleTable" size="mini" :data="tableData" border style="width: 100%" stripe>
        <el-table-column prop="merchantId" label="商户ID">
        </el-table-column>
        <el-table-column prop="date" label="商户名/账号" width="120">
          <template slot-scope="scope">
            <p>{{ scope.row.nickName }}</p>
            <p style="color:#999">{{ scope.row.account }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="realName" label="收款人" width="120">
        </el-table-column>
        <el-table-column prop="bankName" label="收款银行">
        </el-table-column>
        <el-table-column prop="bankNumber" label="收款卡号">
        </el-table-column>
        <el-table-column label="账户余额">
          <template slot-scope="scope">
            <span style="color:green">{{ scope.row.overMoney.toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="allDeposit" label="总存入">
          <template slot-scope="scope">
            <span style="color:green">{{ scope.row.allDeposit.toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="总支出">
          <template slot-scope="scope">
            <span style="color:red">{{ scope.row.allPay.toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.activated" @change="moneystate(scope.row.id)" active-color="#13ce66"
              inactive-color="#ff4949"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width='200'>
          <template slot-scope="scope">
            <el-button size="mini" type="success" @click="moneydetail(scope.row.merchantId)">查看通道收款详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="gs_pagenumber">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
          :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 查看通道收款详情弹框 -->
    <el-dialog title="通道费率" :visible.sync="dialog.show" @close="dialoginit" custom-class="gs_dialog" width="950px">
      <div class="pdb35">
        <h3 class="tc pdb15">通道收款详情</h3>
        <ul class="roadlist clearfix">
          <li v-for="(item, i) in dialog.datalist" :key="'money' + i">
            <span class="tit">{{ item.productType }}</span>
            <div class="content">
              <span style="color:green;">{{ item.amount.toFixed(2) }}</span>
            </div>
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { downSentUrl } from '../../assets/js/version';
import axios from 'axios';
export default {
  data() {
    return {
      tenantId: '', // 商户ID
      accountnumber: '', // 商户账号
      ontherecharge: '', // 充值金额上
      undertherecharge: '', // 充值金额下
      pageIndex: 1, // 页码
      pageSize: 10, // 每页的条数
      total: 0, // 总数据的条数
      tableData: [],
      dialog: {
        show: false,
        datalist: []
      }
    };
  },
  methods: {
    // 资金列表
    getlist() {
      this.$api.money
        .moneylist({
          MerchantId: this.tenantId === '' ? 0 : parseFloat(this.tenantId),
          Account: this.accountnumber,
          MinAmount: this.ontherecharge,
          MaxAmount: this.undertherecharge,
          PageNumber: this.pageIndex,
          PageSize: this.pageSize
        })
        .then((data) => {
          if (data.status === 204) {
            this.tableData = [];
            this.total = 0;
          } else if (data.status === 200) {
            this.tableData = data.data;
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 更改资金状态
    moneystate(id) {
      this.$api.money
        .moneystate({ id: id })
        .then((data) => {
          this.$messageSuccess('更新状态成功！');
          this.getlist();
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 通道收款详情
    moneydetail(id) {
      this.$api.money
        .moneydetail({ MerchantId: id })
        .then((data) => {
          this.dialog.datalist = data.data;
          this.dialog.show = true;
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 弹框的初始化
    dialoginit() {
      this.dialog.datalist = [];
    },
    // 当每页条数变化时
    handleSizeChange(data) {
      this.pageSize = data;
      this.pageIndex = 1;
      this.getlist();
    },
    // 当前的页码变化时
    handleCurrentChange(data) {
      this.pageIndex = data;
      this.getlist();
    },
    //发起自动结算
    autoSettlement() {
      axios('/api/client/AutoSettlement', {
        params: {
          time: 1111
        },
        method: 'post',
        baseURL: downSentUrl
      })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('发起成功');
          }
        })
        .catch(() => {
         
          this.$messageError('发起失败');
        });
    }
  },
  created() {
    this.getlist();
  }
};
</script>

<style lang="scss" scoped>
.opeartbox {
  padding: 15px 20px 5px;
  background: #fff;

  ul {
    li {
      float: left;
      margin-right: 15px;
      margin-bottom: 10px;

      .tit {
        font-size: 14px;
        color: #2d2d2d;
        margin-right: 5px;
      }

      .txtbox {
        display: inline-block;
      }
    }
  }
}

.tableinfo {
  background: #fff;
  padding: 8px 20px;

  table {
    width: 100%;
    color: #272727;
    font-size: 14px;

    td {
      height: 30px;
    }

    .c_3fa396 {
      color: #3fa396;
    }
  }
}

.roadlist {
  border: 1px solid #ccc;
  width: 903px;

  li {
    float: left;
    width: 450px;
    height: 40px;
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    margin-bottom: -1px;

    &:nth-child(2n + 2) {
      border-right: none;
    }

    .tit {
      float: left;
      width: 150px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-right: 1px solid #ccc;
    }

    .content {
      float: left;
      width: 200px;
      height: 32px;
      line-height: 32px;
      padding: 4px 9px;
      text-align: center;
    }
  }
}
</style>
